// React&NextJS
import React, { useEffect, useState } from 'react'
// Types
import { Memory as memoryType } from '../../../types/types'
// Components
import { Button } from '../../core/button/Button'
import { Text } from '../../core/text/Text'
import memoryHelperFunctions from '../../../utils/memoryHelperFunctions'
import s from './Announcements.module.scss'

import helperFunctions from '../../../utils/helperFunctions'

type Props = {
    memory: memoryType
}

const Announcements = ({ memory }: Props) => {
    const [defaultPage, setDefaultPage] = useState(false)

    const { deceased, funeral, greeting } = memory.announcements

    useEffect(() => {
        // check if the funeral not finished or person died within 4 weeks: then it is announcement
        let today = new Date()
        if (memoryHelperFunctions.checkIfFuneralFinished(today, memory)) {
            setDefaultPage(true)
        }
    }, [])

    const createCharityLink = () => {
        let greetingText: string
        if (greeting.charity) {
            greetingText = greeting.charity
        } else {
            greetingText = 'Góðgerðarfélag'
        }

        if (greeting.charityLink) {
            const externalLink = greeting.charityLink.includes(
                'https' || 'http'
            )

            return (
                <Button
                    variant="text"
                    to={
                        externalLink
                            ? greeting.charityLink
                            : `https://${greeting.charityLink}`
                    }
                >
                    {greetingText}
                </Button>
            )
        } else if (greeting.charity) {
            return (
                <Button variant="text" disabled>
                    {greetingText}
                </Button>
            )
        }
    }

    const getStreamExternalLink = () => {
        const streamLink = funeral?.streamLink
        const externalLink = streamLink?.includes('https' || 'http')
        if (externalLink) return streamLink
        return `https://${streamLink}`
    }

    function selectInfo() {
        if (funeral.hold === 'NOW' && !defaultPage) {
            return funeral.text
        } else if (funeral.hold === 'NOW' && defaultPage) {
            if (funeral?.funeralDate) {
                return (
                    'Útför fór fram ' +
                    helperFunctions.getDate(funeral.funeralDate)
                )
            }
            return 'Útför hefur farið fram.'
        } else if (funeral.hold === 'LATER' && !defaultPage) {
            return 'Útför verður tilkynnt síðar.'
        } else if (funeral.hold === 'LATER' && defaultPage) {
            return 'Útför hefur farið fram.'
        } else if (funeral.hold === 'SILENTLY' && !defaultPage) {
            return 'Útför fer fram í kyrrþey.'
        } else if (funeral.hold === 'SILENTLY' && defaultPage) {
            return 'Útför fór fram í kyrrþey.'
        } else if (funeral.hold === 'SILENTLYFIN') {
            return 'Útför fór fram í kyrrþey.'
        } else if (funeral.hold === 'FINISHED') {
            return 'Útför hefur farið fram.'
        }
    }

    return (
        <>
            {deceased?.text && !defaultPage && (
                <div>
                    <Text variant="h6">Andlátstilkynning</Text>
                    <Text variant="p-18">{deceased.text}</Text>
                </div>
            )}
            <div>
                <Text variant="h6">Útför</Text>
                {!defaultPage && (
                    <Text variant="date">
                        {funeral?.funeralDate &&
                            helperFunctions.getDate(funeral.funeralDate, true)}
                    </Text>
                )}
                <Text variant="p-18">{selectInfo()}</Text>
                {(funeral.hold === 'NOW' || funeral.hold === 'FINISHED') &&
                    funeral.streamLink && (
                        <Button
                            variant="text"
                            to={getStreamExternalLink()}
                            disabled={!funeral.streamLink}
                        >
                            Hlekkur á streymi
                        </Button>
                    )}
                {memory.announcements.funeral?.orderOfService && (
                    <Button
                        variant="text"
                        className={s.oos}
                        to={memory.announcements.funeral?.orderOfService}
                    >
                        Sálmaskrá
                    </Button>
                )}
            </div>
            {memory.relatives && (
                <div>
                    <Text variant="h6">Aðstandendur</Text>
                    <Text variant="p-18">{memory.relatives}</Text>
                </div>
            )}
            {(greeting.text || greeting.charityLink || greeting.charity) && (
                <div>
                    {greeting.text && (
                        <>
                            <Text variant="h6">Þakkir</Text>
                            <Text variant="p-18">{greeting?.text}</Text>
                        </>
                    )}
                    {createCharityLink()}
                </div>
            )}
        </>
    )
}

export default Announcements
